<template>
  <div class="introduction-container">
    <img class="introduction-image" src="@/assets/Images/Intro.png">
    <div class="introduction-title">
      Turing Complete
      <br>
      Plasma Chain Building Protocol
    </div>
    <div class="introduction-content">
      Tokamak Network is a platform that assures decentralized and secure
      property same as Ethereum Main chain while supporting high level of
      scalability and extendability. Each Dapp is built easily for specific
      purpose through Tokamak Network.
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.introduction-container {
  padding-right: 32px;
}

.introduction-image {
  margin-bottom: 20px;
  margin-left: 48px;
}

.introduction-title {
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #176ea8;
}

.introduction-content {
  margin-top: 8px;
  font-size: 16px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.63;
  letter-spacing: normal;
  text-align: left;
  color: #6d848e;
  word-break: break-all;
}
</style>
